export interface SensorSnapshot {
  deviceNumber: string;
  sensorIndex: number;
  sensorName: string;
}

export class SensorNameSnapshotter {
  private sensorSnapshots: SensorSnapshot[] = [];

  public append(deviceNumber: string, sensorIndex: number, sensorName: string): void {
    const exists = this.sensorSnapshots.some(
      (snapshot: SensorSnapshot) =>
        snapshot.deviceNumber === deviceNumber && snapshot.sensorIndex === sensorIndex
    );

    if (!exists) {
      this.sensorSnapshots.push({
        deviceNumber,
        sensorIndex,
        sensorName,
      });
    }
  }

  public getSensorName(deviceNumber: string, sensorIndex: number): string | undefined {
    const snapshot = this.sensorSnapshots.find(
      (snapshot: SensorSnapshot) =>
        snapshot.deviceNumber === deviceNumber && snapshot.sensorIndex === sensorIndex
    );
    return snapshot?.sensorName;
  }
}
